// โหมด Audit — ดูอย่างเดียว ปุ่มทุกปุ่มยังโชว์เหมือนเดิม แต่กดแล้วขึ้นแจ้งเตือนแทน
//
// ด่านแรกคือปุ่มบนจอ (เรียก blockIfAudit ต้น handler):
//   - TableInstance       เพิ่ม / ปลดล็อก / note / จำนวนแขก / พิมพ์ตรวจสอบ / จ่ายเงิน
//                         และปุ่มแนวตั้งทั้งหมด (ล็อก, QR, ย้าย, ส่วนลด, ตั้งราคา, แยกบิล, comment, void)
//   - TablePanelSummary   แก้ service charge / ส่วนลดท้ายบิล / card charge / ภาษี
//   - TableInstanceQrCode พิมพ์ / ลบ QR
//   - receipts / ReceiptView  void บิล / เปลี่ยนการจ่ายเงิน / แก้จำนวนแขก / พิมพ์ซ้ำ
//
// ด่านที่สองกันทุกทางที่สร้าง job (สั่ง / void / ย้าย / ฯลฯ) ไม่ให้หลุดลง RTDB จากเครื่อง audit:
//   - cart.ts            submit / submitFromCashier2 / submitFromTerminalToCashier
//   - jobs.ts            add(job, syncToCloud = true)
//   - jobs.cloud.plugin  saveJobToCloud (เผื่อ $onAction ยิงก่อนตัว action)

import Swal from "sweetalert2";
import { RunMode } from "../../../interface/Pos";
import { useRunningMode } from "../../core/composables/useRunningMode";

const FALLBACK_TEXT: Record<string, string> = {
  "pos.audit.blocked_title": "โหมด Audit — ดูอย่างเดียว",
  "pos.audit.blocked_text": "โหมด Audit ไม่สามารถใช้งาน POS ได้ (ดูข้อมูลได้อย่างเดียว)",
};

export function isAuditMode(): boolean {
  return useRunningMode().getMode() === RunMode.AUDIT;
}

/**
 * true = โหมด audit บล็อกไว้แล้ว ผู้เรียกต้อง return ทันที
 * @param action ไว้ log ว่าบล็อกอะไร
 */
export function blockIfAudit(action: string): boolean {
  if (!isAuditMode()) return false;

  console.warn(`[audit] บล็อก ${action} — โหมด Audit ดูอย่างเดียว`);
  void Swal.fire({
    icon: "warning",
    title: auditText("pos.audit.blocked_title"),
    text: auditText("pos.audit.blocked_text"),
  });
  return true;
}

// เรียกจาก store ได้ (นอก setup) — useI18n ใช้ไม่ได้ จึงอ่านผ่าน $i18n ของ nuxt
function auditText(key: string): string {
  try {
    return String(useNuxtApp().$i18n.t(key));
  } catch {
    return FALLBACK_TEXT[key] || key;
  }
}
